import * as React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// Assets
import { brandColors, device, fonts } from '../../styles/variables';

export const Highlight = styled.span`
  font-style: italic;
  font-family: ${fonts.athelas};
`;

const Wrapper = styled.div`
  position: relative;
`;

const StyledTitle = styled.h2`
  ${({ color, primary }) => `
    width: 100%;
    margin-top: 0;
    color: ${color};
    font-family: ${fonts.monterrat};
    font-weight: bold;
    font-style: normal;
    max-width: 295px;
    font-size: 36px;
    line-height: 42px;
    
    @media ${device.tablet} {
      max-width: ${primary ? '815px' : '453px'};
      font-size: ${primary ? '90px' : '36px'};
      line-height: ${primary ? '100px' : '42px'};
    }
  `};
`;

const Subtitle = styled.p`
  position: absolute;
  top: -48px;
  left: 0;
  padding: 0;
  margin: 0;
  color: ${({ color }) => `${color}`};
  font-family: ${fonts.athelas};
  font-style: italic;
  letter-spacing: 1px;
  font-weight: 400;
  font-size: 18px;
  line-height: 38px;
  @media ${device.laptop} {
    top: 16px;
    left: -1px;
    font-size: 22px;
    line-height: 42px;
    transform-origin: 0 0;
    transform: rotate(-90deg) translate(-100%, -100%);
  }
  @media ${device.laptop} {
    left: -20px;
  }
`;

export const Subtext = styled.div`
  width: 100%;
  font-family: ${fonts.athelas};
  font-style: italic;
  letter-spacing: 1px;
  font-weight: 400;
  margin-top: 30px;
  ${({ width, subTextSmall }) => `
    max-width: ${width !== '' ? width : '279px'};
    font-size: ${subTextSmall ? '18px' : '24px'};
    line-height: ${subTextSmall ? '38px' : '44px'};
  `};
  @media ${device.tablet} {
    max-width: 279px;
  }
`;

class Title extends React.PureComponent {
  render() {
    const { children, subtitle, color, primary, className } = this.props;

    let showSubtitle;
    if (subtitle) {
      showSubtitle = (
        <Subtitle color={color} primary={primary}>
          {subtitle}
        </Subtitle>
      );
    }
    return (
      <Wrapper subtitle={subtitle} className={className}>
        <StyledTitle className="Title" color={color} primary={primary}>
          {children}
        </StyledTitle>
        {showSubtitle}
      </Wrapper>
    );
  }
}

Title.defaultProps = {
  subtitle: '',
  color: brandColors.blue,
  primary: true,
  className: '',
  subTextSmall: false
};

Title.propTypes = {
  children: PropTypes.node.isRequired,
  subtitle: PropTypes.string,
  color: PropTypes.string,
  primary: PropTypes.bool,
  className: PropTypes.string,
  subTextSmall: PropTypes.bool
};

export default connect()(Title);



// WEBPACK FOOTER //
// ./src/components/Title/index.jsx